export default __webpack_public_path__ + "static/media/edc-bg.842af82e.png";